import { render, staticRenderFns } from "./SelectView.vue?vue&type=template&id=22dbefaf&scoped=true"
import script from "./SelectView.vue?vue&type=script&lang=js"
export * from "./SelectView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22dbefaf",
  null
  
)

export default component.exports